import type { FaireProductEntity } from "../../entity_types/product";

export const p_u8x67gferp: FaireProductEntity = {
  token: "p_u8x67gferp",
  type: "product",
  name: "The Harbour House Rockpool Oyster Trinket Dish",
  brandName: "CGB Giftware",
  imageUrl:
    "https://cdn.faire.com/fastly/c55024efb724a0f27340fd49083950f4c64dce7d830ee9ab0a9fb89520e04766.jpeg",
  priceDollars: 1.85,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/dcf28c08763bb2e62aedd48c4f2a969c30786d121cc4aec618b3839ecc04e16a.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
